module.exports = __webpack_public_path__ + "img/ic_link.44de4418.svg";